const features = [
  {
    title: '实时更新',
    desc: '7×24 小时持续追踪，第一时间推送最新爆料内容，关注动态不延迟。',
    icon: 'ri-timer-flash-line',
  },
  {
    title: '多领域覆盖',
    desc: '娱乐、社会、科技、体育、财经等 12+ 领域全面覆盖，满足多元信息需求。',
    icon: 'ri-apps-2-line',
  },
  {
    title: '话题竞赛',
    desc: '每日热点大赛排行，参与话题讨论，看谁的爆料更劲爆、更抢眼。',
    icon: 'ri-trophy-line',
  },
  {
    title: '内容聚合',
    desc: '智能聚合全网爆料信息，告别碎片化阅读，一页尽览今日热点全貌。',
    icon: 'ri-stack-line',
  },
  {
    title: '社区互动',
    desc: '评论区自由发言，观点碰撞、深度讨论，让每次爆料都有回响。',
    icon: 'ri-chat-1-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心优势，打造最优质的每日爆料聚合体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/60 text-center transition-all hover:border-primary-200"
            >
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4 transition-colors group-hover:bg-primary-200">
                <i className={`${feat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading whitespace-nowrap">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}